import styled, { css } from "styled-components";

const FilterCard =styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    
    width: 100%;
    min-height: 70px;

    margin: 5px 5px;
    padding-left: 8px;

    box-shadow: rgb(0 0 0 / 16%) 0px 1.5px 3px, rgb(0 0 0 / 23%) 0px 1.5px 3px;
    background: var(--card-background);
    
    position: relative;
    cursor: pointer;

    border-radius: 4px;

    transition: 200ms ease;

    &:hover{
        background: var(--border-color);
    }

    .card-body{
        font-weight: bold;
        color: unset;
        overflow: hidden;
        width: 95%;

        span{
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }
`;

export const PrintStyles = css`
    .onlyPrintElement{
        display: none;
    }  

    @media print{
        @page {
            margin: 1mm;
            body{
                background-color: #FFF;
                color: #474555 !important;
            }
        }

        .noPrintElement{
            display: none;
        }

        .onlyPrintElement{
            display: flex;
        }

        img{
            margin-bottom: 2px; 
            height: 60px; 
            max-width: 300px;
        }

        table {
            border-collapse: collapse;
            width: 100%;
        }
        th{
            background-color: var(--greysofter);
            color: var(--black);
            font-size:14px;
        }

        td{
            font-size:12px;
        }

        table, td, th {  
            border: 1px solid var(--border-color);
            text-align: left;
        }

        th, td {
            padding: 5px;
        }

    }
`;

export const paginationsStlyes = {
	ulContainer: css`
        >div:first-child{
            max-height: fit-content;
        }
        @media print{
            overflow:unset; 
            >div{
                min-height:unset;
                max-height:unset;
                background: var(--greysofter);
            }
        }`,
	row: css`
        flex-wrap: wrap; 
        @media print{
            flex-direction: row !important;
            background-color: var(--greysofter);
            color: var(--black);
            font-size: 8px;
            background-color: var(--greysofter);

            &:nth-child(odd){
                background-color: var(--greysofter);   
            }
        }`,
	header: css`
        flex-wrap: wrap; 
        @media print{
            flex-direction: row !important;
            color: var(--black);
            font-size: 10px;
        }`
};

export const StyledCell = styled.div<{styleInline:string}>`
    ${(props) => props.styleInline && props.styleInline}
`;

export default FilterCard;
